/**
 * DialogActions - MUI DialogActions Component Wrapper
 * 
 * A thin wrapper around Material-UI DialogActions component for consistent imports.
 */

import MuiDialogActions from "@mui/material/DialogActions";

const DialogActions = (props) => {
  return <MuiDialogActions {...props} />;
};

export default DialogActions;

